import { render, staticRenderFns } from "./CardWeServe.vue?vue&type=template&id=fa98c8c2&scoped=true&"
import script from "./CardWeServe.vue?vue&type=script&lang=js&"
export * from "./CardWeServe.vue?vue&type=script&lang=js&"
import style0 from "./CardWeServe.vue?vue&type=style&index=0&id=fa98c8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa98c8c2",
  null
  
)

export default component.exports